import { BlogArticle } from '@models/blog';
import { TaggedSlugEntityPublicApiService } from './taggedSlugEntityPublicApiService';

export class BlogPublicService extends TaggedSlugEntityPublicApiService<BlogArticle> {
    constructor() {
        super('/api/blog');
    }
}
